import commonMixin from '../../mixins/_common';
import modalMixin from '../../mixins/_modal';
import flashMessageMixin from '../../mixins/_flash_messages';

/**
 * パーツ選択コンポーネント
 */
export default {
    name: 'PartsSeleter',
    template: '#parts_selecter_template',
    data() {
        return {
            // 全パーツデータ
            all_parts: {},
            // 追加予定位置
            index: null,
        };
    },
    props: {
        // パーツタイプ
        type: {
            type: String,
            require: true,
        },
        // 編集エリア header、freetext等
        area: {
            type: String,
            require: true,
        },
    },
    computed: {
        // パーツデータが取得済みか
        hasAllParts: function () {
            return (Object.keys(this.all_parts).length > 0);
        },
        // 画面上に表示させるパーツデータ
        displayParts: function () {
            if (!this.hasAllParts) return {};

            return Object.fromEntries(
                Object.entries(this.all_parts).filter(([key]) => this.isShowParts(key))
            );
        }
    },
    mixins: [
        commonMixin,
        modalMixin,
        flashMessageMixin,
    ],
    emits: ['add-parts-data'],
    methods: {
        // モーダルを開く
        show: async function (index) {
            this.index = index;
            if  (this.hasAllParts || await this.getParts()) {
                this.open();
            }
        },
        // パーツ一覧に表示させるか判定
        isShowParts: function (key) {
            // headerブロックは看板パーツ以外非表示
            if (this.area === 'header' && key !== 'header') {
                return false;
            }
            // build_storeのspfreetext1はogaria_tool非表示
            if (this.area !== 'spfreetext1' || key !== 'ogaria_tool') {
                return true;
            }
            return false;
        },
        // パーツ一覧データを取得
        getParts: async function () {
            let message = this.exception_error_message;
            let success = false;
            this.$_loading();
            try {
                const response = await axios.get('/get_parts', {
                    params: {
                        type: this.type
                    }
                });
                if (response.data.status == 'OK') {
                    this.all_parts = response.data.data;
                    success = true;
                    // エラーメッセージを空にする
                    message = '';
                }
            } catch (e) {
                message = this.getCatchMessage(e);
            }
            this.$_unloading();
            if (message) {
                this.appendFlashMessage({
                    level: 'alert-danger',
                    message: message,
                }, this.$parent.$parent);
            }
            return success;
        },
        // 選択したパーツをemitし、モーダルを閉じる
        selectParts: function (partsData) {
            this.emitAddPartsData(partsData);
            this.close();
        },
        // コンポーネント外からパーツデータを取得する
        getPartsData: async function () {
            if  (!this.hasAllParts) await this.getParts();
            return this.all_parts;
        },

        // -------------------------
        // emit
        // -------------------------

        // 親コンポーネントへ通知しパーツを追加
        emitAddPartsData: function (partsData) {
            this.$emit('add-parts-data', partsData, this.index);
        }
    }
};